import React from "react";
import BostonModellen from "../../../Images/BostonModellen.jpg";
import DuPontmodell from "../../../Images/DuPontmodell.jpg";

const Text9 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        LönsamhetsModeller  
        </p>
      
      <div className="content-text mt-4">

        <p className="heading2 mt-4">
          Fokusera med Pareto-analys 
        </p>
        <p>
          Erfarenhetsmässigt står runt 20% av ett företags erbjudanden för c:a 80% av företagets omsättning och därmed ofta dess 
          <i> täckningsbidrag</i> - alltså affärens överskott för att täcka företagets <i>fasta kostnader</i>. 
        </p>
        <p>
          På samma sätt står oftast runt 20 % av ett företags kunder för 80% av omsättning och/eller täckningsbidrag. Fenomenet kallas 
          ”Paretos Lag” och det gäller även för nyföretagare (väl kundkretsen är stor nog att räknas i %).  
        </p>
        <p className="ms-3">
          <i>
            Exempel: Du säljer till butik. Distriktet har 100 st butiker.  Du räknar och finner att runt 20 st står för runt 80% av din 
            omsättning. Vill du gärna satsa resurserna där? 
          </i>   
        </p>
        <p>
          20/80 är ett närmevärde som kan variera. Med reservation: Ju närmare 50/50 du lägger ribban ju meningslösare blir hela övningen. 
          Frågan: Vilka 50 av distriktets butiker står för 50% av omsättningen är ju bortkastad i sammanhanget? 
          Det viktiga är att finna <i>de få</i> som bäst bidrar/kan bidra till att uppnå avsett mål - inte att exakt följa Pareto-tänket. 
        </p>
        <p>
          Trots Paretos Lag ”smetar” många företag oftast ut sina resurser jämt över verksamheten, istället för att disponera dem där de 
          ger maximalt täckningsbidrag över tid. 
        </p>
        <p>
          Att Pareto-fokusera företagets resurser kan vara en snabb och enkel väg mot högre lönsamhet - om och en ganska grov och generell 
          väg. Beroende på vad du väljer att prioritera kan Paretos 20/80-regel snabbt bidra till exempelvis 
        </p>
        <ul>
          <li> Högre Omsättning </li>
          <li className="mt-1"> Ökad Marknadsandel </li>
          <li className="mt-1"> Snabbare Tillväxt </li>
          <li className="mt-1"> Efektivare <i>Utnyttjande</i> - av företagets kostnadsmassa</li>
          <li className="mt-1"> Lägre Kapitalbindning </li>
        </ul>
        <p>
          Googla för mer om hur Paretoanalysen kan appliceras för olika behov. 
        </p>

        <p className="heading2 mt-4">
          Varors/tjänsters livscykel
        </p>
        <p>    
          Varje produkt/erbjudande beskriver en livscykel från första idén till allra sista försäljningstillfället. 
          Genom att hålla koll på var i livscykeln varje erbjudande befinner sig kan du effektivare styra dina resurser dit 
          där de ger bäst påverkan på företagets lönsamhet.                           
        </p>
        <p>
          Nedanstående modell från Boston Consulting Group kan hjälpa dig att hantera <i>livscykler</i> i din produkt- och 
          markandsstrategi.  
        </p>
        <img
          src={BostonModellen}
          alt="imag"
          className="img-fluid max-width:100% height:auto mx-auto d-block"
        />
        <p className="imagetext">
          BostonModellen beskriver resan genom livscykelns fyra olika faser. Varje produkt/erbjudande börjar som ett stort 
          frågetecken överst till höger och slutar som en ”hund” nere till höger. 
        </p>
        <p> 
          <span className="strong"> Förklaring </span> 
        </p>
        <ol>

          <li>
            <span className="strong"> Frågetecken (Wild Cat) </span>
            <p>
              När du tar fram en ny typ eller variant av produkt/marknadserbjudande vet du inte hur värdefullt det arbetet kan visa 
              sig vara. Projektet är ett frågetecken.
            </p>
            <p>
              Hög tillväxt men låg marknadsandel och betydande kostnader som sällan ger  motsvarande inkomster. Här får du verkligen
              se upp så att du skapar stjärnkandidat. 
            </p>
            <ul>
              <li>
                Se noga till att bekräfta kundens behov och upplevelse av ditt planerade erbjudande. Det är lätt att ”fönstershoppa” 
                så försök verkligen sälja (fast erbjudandet ännu inte finns på marknaden) och studera kunden när affären ska göras 
                och ”plånkan ska på bordet”. Där har du svaret. Sanningen. Alltså Kundens sanning. 
              </li>
              <li className="mt-1">
                Håll järnkoll på projektets kostnader. Företagets överlevnad är viktigare än ett enskilt projekt – undantaget ifall 
                företaget bara har ett projekt då. 
              </li>
            </ul>
          </li>

          <li className="mt-3">
            <span className="strong">Stjärna</span>
            <p>
               Om satsningen blir kommersiellt framgångsrik har du tänt en <i>stjärna</i> (symboliskt), som du förmodligen vill bygga 
               största möjliga marknad kring. 
            </p>
            <p>
              Hög tillväxt och hög marknadsandel med höga kostnader för utveckling av marknad och erbjudande som ger höga 
              inkomster tillbaka.  
            </p>
            <p>
              När både utvecklingskostnader och marknadens tillväxt avtagit blir stjärnor antingen ”kassakossa” eller ”hund” 
              direkt beroende på marknadens trend och ditt agerande. 
            </p>
          </li>

          <li>
            <span className="strong"> KassaKossa </span>
            <p> Din <i>kassakossa</i> (Cash Cow) kan mjölka bra under lång tid med få insatser från din sida. </p>
            <p>
              Tillväxten har avtagit men med hög marknadsandel. Varumärket inarbetat. Låga utvecklingskostnader som ger stora inkomster. 
              Bidrar väl till företagets lönsamhet och dess finansiering av andra verksamheter.  
            </p>
            <p>
              Här gäller att sänka kostnaderna med fokus på produktion snarare än på utveckling. Helt enkelt att mjölka så snabbt 
              och effektivt som bara är möjligt 
            </p>
          </li>

          <li>
            <span className="strong"> Hund </span>
            <p>
              Förr eller senare - ofta förr - blir din satsning mindre lönsam. Som en <i>hund</i>. Eller snarare en bitsk byracka. 
              Den ger sällan mer bidrag än vad den kostar och kan till och med bitas. 
            </p>
            <p>
              Har låg tillväxt och låg marknadsandel, drar låga utvecklingskostnader och ger låga intäkter. Går vanligen jämnt upp 
              (break even) och tillför egentligen inte företaget något mervärde, men kräver ändå ofta betydande andel av företagets 
              resurser.
            </p>
            <p>
              Här krävs skepsis. Visst: Killing Your Darlings gör ont men en döende hund kan knappast bidra till ökad lönsamhet – 
              snarare tvärtom. Dina alternativ då för att inte hämma resten av företaget 
            </p>
            <ul>
              <li> Kan Kunden fås att migrera till ett nytt erbjudande (blivande stjärna)? </li>
              <li className="mt-1"> Kan en begränsad insats ge erbjudandet meningsfullt högre lönsamhet? </li>
              <li className="mt-1"> Kan produkt, patent, process, utrustning säljas av? </li>
              <li className="mt-1"> Kan erbjudandet termineras utan konsekvens hos befintliga kunder? </li>
            </ul>
          </li>
        </ol>

        <div className="ms-4">
          <p className="heading3 mt-4">
            Livscykler varierar 
          </p>
          <p>
            Långt ifrån alla dina erbjudanden passerar samtliga fyra livsfaser. En del passerar till exempel direkt från ritbordets ”?” 
            till ”Hund”, utan att någonsin bidra till företagets lönsamhet.
          </p>
          <p>
            Andra (som iPhone) kan vila länge i kassakossa-läget, förutsatt produktutveckling, redesign, och ompaketering för att 
            hålla kossan mjölkande över tid och för att efter hand kalibrera erbjudandet mot dess lönsammaste kundkategorier. 
          </p>
          <p>
            Eller du kanske köper (ett företag med) en stjärna och slipper utveckling och att bygga marknad. 
          </p>

          <p className="heading3 mt-4">
            Rid på LivsCykeln  
          </p>
          <p>
            Så får du ut mesta möjliga ur samtliga delar av ditt utbud - nu och över tid?  
          </p>
          <ol>
            <li> Skapa bara nytt för att öka Kundens värdeupplevelse - aldrig för att slå konkurrenter </li>
            <li className="mt-1"> Kom till ”stjärnstatus” snabbast möjligt </li>
            <li className="mt-1"> Hjälp ”kossan” mjölka mer och längre </li>
            <li className="mt-1"> Skaka liv i tynande ”hund” - alternativt avyttra om det går eller avliva </li>
          </ol>
          <p>
            Gör Bostonanalysen återkommande och konsekvent och uppdatera <i>löpande</i> cykel-strategin för varje erbjudande. 
            Din bedömning av livsfas kan bli fel eller inaktuell. 
          </p>
        </div>

        <p className="heading2 mt-4">
          Kapitalets Lönsamhet   
        </p>
        <p>
          Ett vanligt mått på lönsamhet för många företag är storleken på det investerade kapitalets avkastning (räntabilitet). 
          Speciellt viktigt för företag med extern finansiering - men även dina egna(s) pengar ska väl ge mer än en motsvarande 
          (trygg) insättning på banken? 
        </p>
        <p>
          Räntabilitet på Totalt Investerat Kapital förkortas ”Rt”. Ett mått på hur effektivt företaget utnyttjar kapitalet för 
          sin lönsamhet. Ju effektivare utnyttjande - ju högre Rt per investerad krona.  
        </p>
        <p> Exempel på enkla åtgärder för att höja kapitalets räntabilitet kan vara att </p>
        <ul>
          <li> Driva in Kundfordringar (snabb fakturering, kort kredit, minska ”släpande” fakturor) </li>
          <li className="mt-1"> Minska Lagerbindning (mindre lager) </li>
          <li className="mt-1"> Betala senast möjligt (tidigast på sista betaldatum) </li>
        </ul>
        <p>
          Det handlar alltså om ökad nettovinst och snabbare ”snurr” på kapitalet. Högre effektivitet. Mer för samma slant. 
          Genom ännu smartare maskinbeläggning, moderniserat underhåll, investering i nya effektivare maskiner och utrustning o s v. 
        </p>
        <p>
          För att få bra överblick på förhållandet mellan intäkter, kostnader, vinst och bundet kapital används ”duPont-Modellen” nedan. 
          En ”spelplan” för att finna åtgärder som höjer Rt. 
        </p>
        <img
          src={DuPontmodell}
          alt="imag"
          className="img-fluid max-width:100% height:auto mx-auto d-block"
        />
        <p className="imagetext">
          Tecken mellan boxar beskriver räknesättet för att få fram värdet för nästa box till höger. 
        </p>
           
        <p>
          Näst längst till höger i diagrammet ser du hur Rt-måttet fås ur produkten av företagets Vinstmarginal (%) gånger kapitalets 
          Omsättningshastighet, så här  
        </p>
        <p className="ms-3">
          <i> Vinstmarginal x Omsättningshastighet = Räntabilitet på Totalt Kapital (Rt) </i>
        </p>
        <p>
          I diagrammet kan du alltså följa hur exempelvis utestående/obetalda Fodringar längst till vänster påverkar kapitalets 
          omsättningshastighet, som i sin tur påverkar Rt-måttet. 
        </p>

        

      </div>
    </>
  );
}
export default Text9;